import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import router from "../router"

export interface ContextState {
  initialized: boolean
  profile: IProfile,
  jwtToken: string | null
}
export interface IProfile {
  username: string,
  name: string, 
  email: string,
  isAdmin: boolean
}

export interface ICredentials {
  username: string,
  password: string, 
}

const store = {
  namespaced: true,
  state: {
    initialized: false,
    profile: {} as IProfile,
    jwtToken: null
  } as ContextState,

  getters: {
    isAuthenticated: (state: ContextState) => state.profile.name || state.profile.email,
    isAdmin: (state: ContextState) => state.profile.isAdmin
  },

  mutations: {
    setProfile (state: ContextState, profile: IProfile) {
      state.profile = profile
    },
    setJwtToken (state: ContextState, jwtToken: string) {
      state.jwtToken = jwtToken

      // WARNING: storing JWT tokens in local storage or anywhere accessible by JavaScript is a security issue!
      // This is just for demonstrative purposes on how SignalR can be authenticated using JWT
      // Store token securily on a real application
      // For example, a web app can store them in cookies not accessible to JavaScript, while a native app will need to use the device secure storage
      if (jwtToken) 
        window.localStorage.setItem('jwtToken', jwtToken)
      else 
        window.localStorage.removeItem('jwtToken')
    }
  },

  actions: {
    // Used during startup to reload the profile from the server
    restoreContext ({ commit, getters, state }: { commit: any, getters: any, state: ContextState }) {
      const jwtToken = window.localStorage.getItem('jwtToken')
      if (jwtToken) commit('setJwtToken', jwtToken)

      return axios.get('/account/context')
        .then(res => {
          commit('setProfile', res.data)
          // if (getters.isAuthenticated)
          //   return Vue.prototype.startSignalR(state.jwtToken)
        })
        .finally(()=> {
          state.initialized = true;
        })
    },
    // Login methods. Either use cookie-based auth or jwt-based auth
    login ({ state, dispatch }: {state: ContextState, dispatch: any}, { authMethod, credentials} : {authMethod: string, credentials: ICredentials}) {
      const loginAction = authMethod === 'jwt'
        ? dispatch('loginToken', credentials)
        : dispatch('loginCookies', credentials)

      return loginAction; //.then(() => Vue.prototype.startSignalR(state.jwtToken))
    },
    loginCookies ({ commit }: { commit: any}, credentials: ICredentials) {
      return axios.post('/account/login', credentials)
        .then(res => {
          commit('setProfile', res.data)
          return res.data;
        })
        .catch((res) => {
          if (res.response && res.response.status == 401) {
            throw res.response.data;
          }

          throw res;
        })
    },
    loginToken ({ commit }: { commit: any}, credentials: ICredentials) {
      return axios.post('/account/token', credentials)
        .then(res => {
          const profile = res.data
          const jwtToken = res.data.token
          delete profile.token
          commit('setProfile', profile)
          commit('setJwtToken', jwtToken)
        })
    },
    // Logout. (With JWT the request isnt strictly necessary unless the server needs some cleanup/auditing)
    logout ({ commit, state }: { commit: any, state: ContextState}) {

      if (state.jwtToken) {
        commit('setProfile', {})
        commit('setJwtToken', null)

        router.push('login');
      } else {
        axios.post('/account/logout').then(() => {
          commit('setProfile', {})
          commit('setJwtToken', null)
        })
        .finally(() => router.push({name: 'login' }))
      }
    }
  }
}

export default store